// @flow

import React from "react";
import { localize } from "redux-i18n";
import { List } from "@components";

type Props = $Exact<{
  ...PropsFromLocalize,
}>;

class ReferralsPromotion extends React.Component<Props> {
  get features() {
    return [
      {
        key: "health",
        value: this.props.t("REFERRAL_PROMOTION_HEALTH"),
      },
      {
        key: "compatibility",
        value: this.props.t("REFERRAL_PROMOTION_COMPATIBILITY"),
      },
      {
        key: "forms",
        value: this.props.t("REFERRAL_PROMOTION_FORMS"),
      },
      {
        key: "guidance",
        value: this.props.t("REFERRAL_PROMOTION_LINE_GUIDANCE"),
      },
      {
        key: "reports",
        value: this.props.t("REFERRAL_PROMOTION_REPORTS"),
      },
      {
        key: "history",
        value: this.props.t("REFERRAL_PROMOTION_HISTORY"),
      },
      {
        key: "more",
        value: this.props.t("REFERRAL_PROMOTION_MORE"),
      },
    ];
  }

  get benefits() {
    return [
      {
        key: "occupationa-health",
        value: this.props.t("REFERRAL_PROMOTION_OCCUPATIONAL_HEALTH"),
      },
      {
        key: "waiting-times",
        value: this.props.t("REFERRAL_PROMOTION_WAITING_TIMES"),
      },
      {
        key: "transparency",
        value: this.props.t("REFERRAL_PROMOTION_TRANSPARENCY"),
      },
      {
        key: "intervention",
        value: this.props.t("REFERRAL_PROMOTION_INTERVENTION"),
      },
    ];
  }

  render() {
    return (
      <div className="p-4 bg-grey rounded h-462-px">
        <h4 className="mb-3">{this.props.t("UPGRADE_ACCOUNT")}</h4>
        <div className="d-flex gap-14">
          <div>
            <List list={this.features} title={this.props.t("FEATURES")} />
            <List list={this.benefits} title={this.props.t("BENEFITS")} />
          </div>
          <div>
            <img
              className="w-450-px h-300-px"
              src="/assets/img/referrals-image.jpeg"
              alt={this.props.t("REFERRAL_PROMOTION_ALT_TEXT")}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default localize()(ReferralsPromotion);
